import React, { Component } from "react";

export default class extends Component {
  audio = null;

  playRecording = () => {
    this.audio = new window.Audio(this.props.savedClip);
    this.audio.play();
    this.audio.onended = () => this.props.onended();
  };

  pause = () => this.audio?.pause();

  render = () => <></>;
}
